import { useState, useEffect } from 'react';

export const useIdle = (timeout = 2000) => {
  const [isIdle, setIsIdle] = useState(false);

  useEffect(() => {
    let timeoutId;

    const handleIdle = () => {
      setIsIdle(true);
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(handleIdle, { timeout });
    } else {
      timeoutId = setTimeout(handleIdle, timeout);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeout]);

  return isIdle;
};

